import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AppConfig } from '../../Config'
dayjs.extend(utc);
dayjs.extend(timezone);

export const statusView = (userStatus, processing) => {
  if(processing) {
    return <div className='tw-py-2 tw-w-min tw-whitespace-nowrap tw-px-4 tw-bg-[#FF9D00] tw-rounded-md tw-text-white'>
    Payment Pending
  </div>
  }
    switch(userStatus) {
      case 'Active':
        return <div className='tw-py-2 tw-w-min tw-whitespace-nowrap tw-px-4 tw-bg-[#22C55E] tw-rounded-md tw-text-white'>
          Subscription is active.
        </div>
      case 'Grace Period':
        return <div className='tw-py-2 tw-w-min tw-whitespace-nowrap tw-px-4 tw-bg-[#FF9D00] tw-rounded-md tw-text-white'>
          Subscription is in grace period.
        </div>
      case 'Payment Pending': 
        return <div className='tw-py-2 tw-w-min tw-whitespace-nowrap tw-px-4 tw-bg-[#FF9D00] tw-rounded-md tw-text-white'>
          Payment Pending
        </div>
      case 'No Subscription':
      case 'Unlisted Due to Payment':
      case 'Cancelled':
        return <div className='tw-py-2 tw-w-min tw-whitespace-nowrap tw-px-4 tw-bg-[#AAAAAA] tw-rounded-md tw-text-white'>
          Subscription is inactive.
        </div>      
    } 
  }

export const cancelView = (userStatus, cancelOnNextRenew, onCancel) => {
    switch(userStatus) {
      case 'Active':
      case 'Grace Period':
        if(!cancelOnNextRenew) {
          return <div>
          <button className='tw-text-[#ff0000] tw-font-light tw-text-sm tw-bg-transparent'
          onClick={onCancel}
          style={{
            border: '1px solid transparent'
          }}>
            Cancel subscription 
          </button>
        </div>
        } else {
          return <div></div>
        }
        
      case 'Payment Pending':
      case 'Cancelled':
      case 'No Subscription':
      case 'Unlisted Due to Payment':
        return <div></div>
    } 
  }

export const subscriptionFormatedDate = (date, timezone) => {
  if(timezone) {
    return `${dayjs.tz(date, timezone).format('MM/DD/YYYY')} (${timezone})`;
  } else {
    return dayjs(date).format('MM/DD/YYYY');
  }
}

export const statusDescriptionView = (userStatus, renewDate, endOfGraceDate, processing, cancelOnNextRenew, timezone) => {
    if(processing) {
      return <div>
      Your payment is being processed by your bank. The status will update once it is complete.
    </div>
    }
    switch(userStatus) {
      case 'No Subscription':
      case 'Active':
        if(cancelOnNextRenew) {
          return <div>
            Your subscription has been canceled. It ends on {subscriptionFormatedDate(renewDate, timezone)}.
          </div>
        }
        return <></>
      case 'Cancelled':
        return <div>
          Your subscription has been canceled. You can reactivate it on the Subscription Plans page.
        </div>
      case 'Grace Period':
        return <div className='tw-text-[#FF0000] tw-font-bold tw-text-xs'>
            Your subscription is in a grace period due to a failed payment. 
            This may be due to insufficient funds, an expired card, or a bank issue. 
            Your properties will become inactive on {subscriptionFormatedDate(endOfGraceDate, timezone)} if no action is taken. Please update your payment method to 
            avoid interruption. <a className="tw-text-[#FF0000] tw-font-bold tw-underline" href={'/contact'}>
            Contact support
          </a> if you need help.
        </div>
      case 'Payment Pending':
        return <div>
          Your payment is being processed by your bank. The status will update once it is complete.
        </div>
      case 'Unlisted Due to Payment':
        return <div>
          Your properties have become inactive.
        </div>
    } 
  }
